import React from 'react';
import IndependencePayment from './IndependencePayment';

const Payment = () => <IndependencePayment />;

export default Payment;
